import {EntityType, KeyTag, KeyTagForm} from "./Model";
import {EntityStore, startEntityStore} from "./resourceStoreBuilder";
import Subscription from "../util/Subscription";
import {create} from "zustand";
import {officeArrayResource} from "./CurrentOfficeStore";
import {KeyTags_Read} from "../util/access/Permission";

export const keyTagSubscription = new Subscription();

interface KeyTagStore extends EntityStore<KeyTag[]> {
    createKeyTag: (form: KeyTagForm) => Promise<KeyTag>,
    updateKeyTag: (keyTag: KeyTag, form: KeyTagForm) => Promise<KeyTag>,
    deleteKeyTag: (keyTag: KeyTag) => Promise<void>,
}

export const useKeyTagStore = create<KeyTagStore>()(
    officeArrayResource<KeyTag, KeyTagStore>(EntityType.KeyTags, builder => {
        const rest = builder.crud<KeyTagForm>('/key-tags', 'id');

        return {
            remoteValue: builder.all(KeyTags_Read, () => rest.getAll()),
            createKeyTag: builder.createAndPatch<KeyTagForm>(rest),
            updateKeyTag: builder.updateAndPatch<KeyTagForm>(rest, keyTagSubscription),
            deleteKeyTag: builder.deleteAndPatch<KeyTagForm>(rest, keyTagSubscription),
        };
    })
);

startEntityStore(useKeyTagStore);
